var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.848 9.20805L8 2.05605L15.152 9.20805C15.248 9.30405 15.3653 9.35205 15.504 9.35205C15.6427 9.35205 15.76 9.30405 15.856 9.20805C15.952 9.11205 16 8.99472 16 8.85605C16 8.71738 15.952 8.60005 15.856 8.50405L8 0.64805L0.143999 8.50405C0.0480003 8.60005 0 8.71738 0 8.85605C0 8.99472 0.0480003 9.11205 0.143999 9.20805C0.24 9.30405 0.357332 9.35205 0.495999 9.35205C0.634666 9.35205 0.751999 9.30405 0.848 9.20805Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUp);
export default __webpack_public_path__ + "static/media/FilterUp.f3d712257387346f5da16d357107a399.svg";
export { ForwardRef as ReactComponent };